export default __webpack_public_path__ + "static/media/Nephrologist-Care-280x215.cc822f46.jpg";